import type { PhotoCarGuide } from "./carGuideTypes";

const BASE = "/assets/car_interior_guides";

/** Guided interior shots 1–7; photos 8–15 are optional. */
export const INTERIOR_GUIDED_COUNT = 7;

export const INTERIOR_CAR_GUIDES: PhotoCarGuide[] = [
  {
    id: "passenger_outside",
    imageSrc: `${BASE}/passenger_outside_view.png`,
    labelKey: "passengerOutside",
    widthPct: 92,
    maxHeightPct: 78,
    scale: 1.05,
  },
  {
    id: "front_seats_behind",
    imageSrc: `${BASE}/front_seats_view_from_behind.png`,
    labelKey: "frontSeatsFromBehind",
    widthPct: 90,
    maxHeightPct: 76,
  },
  {
    id: "center_console",
    imageSrc: `${BASE}/center_console.png`,
    labelKey: "centerConsole",
    widthPct: 88,
    maxHeightPct: 74,
    scale: 1.02,
  },
  {
    id: "cockpit",
    imageSrc: `${BASE}/cockpit.png`,
    labelKey: "cockpit",
    widthPct: 90,
    maxHeightPct: 76,
    scale: 1.06,
  },
  {
    id: "back_seats",
    imageSrc: `${BASE}/back_seats.png`,
    labelKey: "backSeats",
    widthPct: 90,
    maxHeightPct: 76,
    scale: 1.04,
  },
  {
    id: "back_seats_outside",
    imageSrc: `${BASE}/back_seats_outside_view.png`,
    labelKey: "backSeatsOutside",
    widthPct: 92,
    maxHeightPct: 78,
    scale: 1.05,
  },
  {
    id: "trunk",
    imageSrc: `${BASE}/trunk.png`,
    labelKey: "trunk",
    widthPct: 90,
    maxHeightPct: 72,
    scale: 1.08,
  },
];

export function getInteriorGuideForPhotoIndex(
  photoIndex: number,
): PhotoCarGuide | null {
  if (photoIndex < 1 || photoIndex > INTERIOR_GUIDED_COUNT) return null;
  return INTERIOR_CAR_GUIDES[photoIndex - 1] ?? null;
}
